<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import Membership from 'components/Membership'

export default {
  name: 'membership-modal',
  components: {
    Membership,
  },
  props: {},
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
    }),
  },
  data() {
    return {
      loading: false,
      modalVisible: false,
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    onClosed() {
      this.modalVisible = false

      this.reset()

      setTimeout(() => {
        this.$emit('closed')
      }, 400)
    },
    reset() {},
  },
  mounted() {},
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipModal/index.vue